export const docs = {
  namespaced: true,
  state: {
    pages: {},
    trees: {},
  },
  getters: {},
  // Sync process only
  mutations: {
    setContent(state, payload) {
      state.pages = Object.assign({}, state.pages, {
        [payload.name]: payload.value,
      })
    },
    setTree(state, payload) {
      state.trees = Object.assign({}, state.trees, {
        [payload.name]: payload.value,
      })
    },
  },
  // Async process, External API linkage
  actions: {},
}
